import { Routes } from '@angular/router';
import { UserLoginComponent } from './components/user/user-login/user-login.component'; // Import the LoginComponent
import { UserRegisterComponent } from './components/user/user-register/user-register.component';
import {
  UserForgotPasswordComponent
} from './components/user/user-forgot-password/user-forgot-password.component';
import {
  UserResetPasswordComponent
} from './components/user/user-reset-password/user-reset-password.component';
import { AuthGuard } from './guards/auth.guard';
import { LogicTestComponent } from './components/util/logic-test/logic-test.component';
import { lazyRetry } from './components/util/routing-util/routing-lazy-retry';
import { AIChatbotComponent } from './components/shared/ai/ai-chatbot/ai-chatbot.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'topmenu/project',
    pathMatch: 'full',
    //canActivate: [AuthGuard]
  },
  {
    path: 'topmenu/account',
    data: { menuid: 'account' },
    loadComponent: () => 
      lazyRetry(() =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage)
    ),
    children: [
      {
        path: '',
        loadChildren: () =>
        lazyRetry(() =>
          import('src/app/components/account/account-routing').then((m) => m.AccountRoutes)
        ),
      }
    ],
    //canActivate: [AuthGuard]
  },
 {
    path: 'help/browser-test',
    loadComponent: () =>
      import('src/app/components/help/browser-test/browser-test.component').then((m) => m.BrowserTestComponent),
  },
 {
    path: 'help/display-diagnostics',
    loadComponent: () =>
      import('src/app/components/help/display-diagnostics/display-diagnostics.component').then((m) => m.DisplayDiagnosticsComponent),
  },
  //cns: technical debt.  This is a workaround for the issue where the user is redirected to user-login from logout
  {
    //original logout path / navigation link.  calls next path 'user-login'
    path: 'util/logic-test',
    loadComponent: () => LogicTestComponent,
  },
  {
    //original logout path / navigation link.  calls next path 'user-login'
    path: 'ai/ai-chatbot',
    loadComponent: () => AIChatbotComponent,
  },
  {
    //original logout path / navigation link.  calls next path 'user-login'
    path: 'user/user-logout',
    data: { action: 'logout',excludeIdle: true },
    loadComponent: () => UserLoginComponent,
  },
  {
    //only happens when called from user/user-logout
    path: 'user-login',
    data: { excludeIdle: true, anonymous: true  },
    redirectTo: 'user/user-login/logout',
  },
  {
    //redirected here from user-login, which is called from logout
    path: 'user/user-login/logout',
    data: { action: 'logout',excludeIdle: true, anonymous: true   },
    loadComponent: () => UserLoginComponent,
    
  },
  {
    //when called directly from URL
    path: 'user/user-login',
    data: { action: 'none',excludeIdle: true, anonymous: true },
    loadComponent: () => UserLoginComponent,
  },
  {
    //when called directly from URL
    path: 'user/user-register',
    data: { excludeIdle: true, anonymous: true  },
    //data: { action: 'none'},
    loadComponent: () => UserRegisterComponent,
  },
  {
    //when called directly from URL
    path: 'user/user-forgot-password',
    //data: { action: 'none'},
    data: { excludeIdle: true, anonymous: true  },
    loadComponent: () => UserForgotPasswordComponent,
  },
  {
    //when called directly from URL
    path: 'user/user-reset-password',
    data: { excludeIdle: true, anonymous: true  },
    //data: { action: 'none'},
    loadComponent: () => UserResetPasswordComponent,
  },

  {
    path: 'topmenu/notifications',
    data: { menuid: 'notifications' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadComponent: () => import('src/app/components/notifications/notifications.component').then((m) => m.NotificationsComponent),
      }
    ],
    // canActivate: [AuthGuard]
  },

  {
    path: 'topmenu/project',
    data: { menuid: 'project' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/components/project/project-routing').then((m) => m.ProjectRoutes),
      }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: 'topmenu/quotes',
    data: { menuid: 'quotes' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadComponent: () => import('src/app/components/project-quotes-global/project-quotes-global.component').then((m) => m.ProjectQuotesGlobalComponent),
      }
    ],
    // canActivate: [AuthGuard]
  },
  {
    path: 'topmenu/orders',
    data: { menuid: 'orders' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadComponent: () => import('src/app/components/project-orders/project-orders.component').then((m) => m.ProjectOrdersComponent),
      }
    ],
    // canActivate: [AuthGuard]
  },
  {
    path: 'topmenu/reports',
    data: { menuid: 'reports' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadComponent: () => import('src/app/components/report/powerbi/powerbi.component').then((m) => m.PowerbiComponent),
      }
    ],
    // canActivate: [AuthGuard]
  },  
  {
    path: 'topmenu/admin',
    data: { menuid: 'admin' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/components/admin/admin-routing').then((m) => m.AdminRoutes),
      }
    ],
    //canActivate: [AuthGuard]

  },
  // {
  //   path: 'topmenu/manage',
  //   redirectTo: 'topmenu/manage/product-types',
  //   pathMatch: 'full'
  // },
  // {
  //   path: 'topmenu/manage',
  //   data: { menuid: 'management' },
  //   loadComponent: () =>
  //     import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () => import('src/app/components/manage/manage-routing').then((m) => m.ManageRoutes),
  //     }
  //   ]
  // },
  {
    path: 'topmenu/help',
    data: { menuid: 'help' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadComponent: () => import('src/app/components/help/help.component').then((m) => m.HelpComponent),
      }
    ],
    // canActivate: [AuthGuard]
  },
   {
    path: 'topmenu/:menuid',
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: 'project',
        loadComponent: () =>
          import('src/app/components/project/project-main/project-main.component').then((m) => m.ProjectMainComponent),
      },
    ],

  },
  {
    path: 'topmenu/user',
    data: { menuid: 'user' },
    loadComponent: () =>
      import('src/app/components/topmenu/topmenu.page').then((m) => m.TopMenuPage),
    children: [
      {
        path: '',
        loadChildren: () => import('src/app/components/user/user-routing').then((m) => m.UserRoutes),
      }
    ]
  },
  {
    path: 'project/project-detail/:projectId/project-properties-advanced',
    loadComponent: () => import('src/app/components/project/project-properties-advanced/project-form-advanced/project-form-advanced.component').then((m) => m.ProjectFormAdvancedComponent),
  }
];
